import React from "react";
import PropTypes from "prop-types";
import { Heading } from "../Heading";

import styles from "./Imprint.scss";

const variants = {
  primary: [
    Heading.Variant.primary,
    styles["primary-headline"],
    styles.headline,
  ],
  secondary: [
    Heading.Variant.quaternary,
    Heading.Variant.highlight,
    styles["secondary-headline"],
    styles.headline,
  ],
};

function ImprintHeadline({ children, variant, ...otherProps }) {
  return (
    <Heading variants={variants[variant]} {...otherProps}>
      {children}
    </Heading>
  );
}

ImprintHeadline.Variant = {
  primary: "primary",
  secondary: "secondary",
};

ImprintHeadline.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variant: PropTypes.oneOf(Object.values(ImprintHeadline.Variant)).isRequired,
};

ImprintHeadline.displayName = "Imprint.Headline";

export default ImprintHeadline;
